import ValueTracker from "../../../../prop-trackers/value-tracker.js";
import PropTracker from "../../../../prop-trackers/prop-tracker.js";
import SinglePropTracker from "../../../../prop-trackers/single-prop-tracker.js";
import { ForEach, ValueTracker as ForEachValueTracker } from "../../../../prop-tracker-utils/for-each.js";

class PbrMaterialPropertyTrackerAssigner {
    constructor(evtCtx, shlWrapCtx, shlEvtCtx, pbrMatEnvLightAssigner) {
        this._envLightInfo = shlWrapCtx.getWrapper({});
        this._envLightInfoEvents = shlEvtCtx.getEvents(this._envLightInfo);

        this._materialTracker = new PropTracker();
        this._forEachTracker = new ForEach(this._materialTracker, (key) => new MaterialTracker(evtCtx, pbrMatEnvLightAssigner, this._envLightInfo, this._envLightInfoEvents));
    }

    trackMaterials(materials, materialEvents) {
        this._materialTracker.track(materials, materialEvents);
    }

    trackEnvLight(envLight, envLightEvents) {
        if (envLight) {
            this._envLightInfo.envLight = envLight;
            this._envLightInfo.envLightEvents = envLightEvents;
        } else {
            delete this._envLightInfo.envLight;
            delete this._envLightInfo.envLightEvents;
        }
    }

    update() {
        this._forEachTracker.updateIfNeeded(({ trackers }) => {
            for (const tracker of trackers) {
                tracker.update();
            }
        });
    }
}

class MaterialTracker extends ForEachValueTracker {
    constructor(evtCtx, pbrMatEnvLightAssigner, envLightInfo, envLightInfoEvents) {
        super();

        this._evtCtx = evtCtx;
        this._pbrMatEnvLightAssigner = pbrMatEnvLightAssigner;
        this._envLightInfo = envLightInfo;
        this._envLightInfoEvents = envLightInfoEvents;

        this._envLightInfoTracker = new PropTracker();
        this._materialTracker = new ValueTracker();
        this._envLightTracker = new SinglePropTracker();

        const needsUpdate = () => this.protected_needsUpdate();
        this._envLightInfoTracker.listenNeedsUpdate(needsUpdate);
        this._materialTracker.listenNeedsUpdate(needsUpdate);
        this._envLightTracker.listenNeedsUpdate(needsUpdate);
    }

    setValue(material) {
        if (material) {
            this._materialTracker.setValue(material);
            this._envLightInfoTracker.track(this._envLightInfo, this._envLightInfoEvents);
        } else {
            this.deleteValue();
        }
    }

    deleteValue() {
        this._materialTracker.deleteValue();
        this._envLightInfoTracker.track();
    }

    protected_startUpdate() {
        this._envLightInfoTracker.updateIfNeeded(({ props }) => {
            const data = props.get("envLight").newValue;
            const events = props.get("envLightEvents").newValue;

            this._envLightTracker.track(data, events, "value");
        });

        if (this._materialTracker.needsUpdate || this._envLightTracker.needsUpdate) {
            this._materialTracker.update(({ prop: { newValue: material } }) => {
                this._envLightTracker.update(({ prop: { newValue: envLight } }) => {
                    if (material) {
                        this._pbrMatEnvLightAssigner.setProperty(material, envLight || null);
                    }
                });
            });
        }
    }

    protected_finishUpdate() {}
}

export default PbrMaterialPropertyTrackerAssigner;
